import React from 'react'
import AutoplaySwi from './AutoplaySwi'
import './Ai.css';
const Ai = () => {
  return (
    <>

       <div className='Aiart'><span> AI </span> ART</div>
        <AutoplaySwi
            spl=""
            img1="image/Aiimg/AiDeveloper/1.webp"
            img2="image/Aiimg/AiDeveloper/2.webp"
            img3="image/Aiimg/AiDeveloper/3.jpg"
            img4="image/Aiimg/AiDeveloper/4.webp"
            img5="image/Aiimg/AiDeveloper/5.webp"
            img6="image/Aiimg/AiDeveloper/2.webp"
        />
        <AutoplaySwi
            spl="3"
            img1="image/Aiimg/1.webp"
            img2="image/Aiimg/2.webp"
            img3="image/Aiimg/3.webp"
            img4="image/Aiimg/4.webp"
            img5="image/Aiimg/5.webp"
            img6="image/Aiimg/6.webp"
        />
        <div className="aiblog">
            <div className='blog_area'>
                <p>
                    <span> AI </span> art is a rapidly growing field that combines the power of artificial intelligence with the creativity of human artists. With the advancements in technology, AI is now able to create unique and compelling art that can rival that of human artists.
                </p>
                <br/>
                <p>
                One of the most exciting things about AI art is its ability to create new forms of art that have never been seen before. For example, AI algorithms can generate entirely new images, videos, and even music that are completely unique and often quite beautiful. This opens up a whole new world of possibilities for artists and art enthusiasts alike
                </p>
                <br/>
                <p>
                    AI art has many advantages over traditional art forms. For example, it can be created much faster, and it can be more realistic and detailed. Additionally, AI art can be created in a wide range of styles, from photorealistic to abstract.
                    However, AI art also has some limitations. For example, it is not yet possible to create truly original art using AI, as the algorithms are based on existing data. Additionally, AI art is often seen as lacking the human touch and emotional depth of traditional art forms.
                </p>



            </div>

            
        </div>
        <AutoplaySwi
                img1="image/Aiimg/a.webp"
                img2="image/Aiimg/b.webp"
                img3="image/Aiimg/c.webp"
                img4="image/Aiimg/d.webp"
                img5="image/Aiimg/e.webp"
                img6="image/Aiimg/6.webp"
        />   



    </>
  )
}

export default Ai